module.exports = __webpack_public_path__ + "img/protoring-codeTest-rightArrow.657bf619.svg";